import { useMemo } from 'react'

import { useParams } from 'react-router-dom'
import { useGetTermsGlobalAccount } from 'services/terms-global-account/useTermsGlobalAccount'
import { handleSelectTerm } from 'utils'

export function TermsGlobalAccountViewer() {
  const { id } = useParams<{ id: string; isWebview?: string }>()
  const { data } = useGetTermsGlobalAccount()

  const term = useMemo(() => !!data && data.find((item) => item.id === id), [data, id])

  const NativeTerms = () => {
    !!term && handleSelectTerm(term)
    return <></>
  }

  if (!term) return null

  return NativeTerms()
}
